module.exports = "<div [style.background-image]=\"'url('+image+')'\" [style.height]=\"height+'px'\" class=\"image\">\n  <div *ngIf=\"uploading\" class=\"uploading\">\n    <span class=\"spinning icon ion-load-c\"></span>\n  </div>\n  <div class=\"set-image\">\n    <input type=\"file\" ng2FileSelect=\"ng2FileSelect\" [uploader]=\"uploader\" class=\"file-input\" />\n    <div class=\"icon ion-camera\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/upload/upload.component.html
// module id = 195
// module chunks = 1